/* @flow weak */
import PropTypes from 'prop-types';
import * as React from 'react';
import Select from 'components/Select.jsx';
import Groups from 'collections/Groups';
import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import Field from 'components/Field.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Label from 'components/Label.jsx';
import Legend from 'components/Legend.jsx';
import SubscriberActions from 'actions/SubscriberActions';
import SetUserEmailModal from 'settings/components/SetUserEmailModal.jsx';
import SettingsContainer from './SettingsContainer.jsx';
import CurrentUser from 'auth/CurrentUser';
import { mountModal } from 'lib/modal';
import { ALL_TOKENS_ITEM } from 'components/Tokenizer.jsx';

const ALL_CLASSES_OPTION = { label: 'All classes', value: ALL_TOKENS_ITEM };

class PrintSubscribers extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    groups: PropTypes.instanceOf(Groups).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      group: ALL_CLASSES_OPTION,
      groupOptions: this.getFormattedGroupSelectOptions(),
    };
  }

  getFormattedGroupSelectOptions = () => {
    return [ALL_CLASSES_OPTION].concat(
      this.props.groups.map(group => {
        return { label: group.getName(), value: group.id };
      })
    );
  };

  setSelectedGroup = value => {
    const group = this.state.groupOptions.find(option => option.value === value);
    this.setState({ group });
  };

  hasSelectedGroup = () => {
    return this.state.group !== null;
  };

  printSubscribers = (): void => {
    if (!CurrentUser.hasEmail()) {
      mountModal(<SetUserEmailModal onSave={this.printSubscribers} />, this);
      return;
    }

    let groupIds;

    // if selected group is all class pass an empty array.
    const allGroups = ALL_CLASSES_OPTION.value;
    if (this.state.group.value === allGroups) {
      groupIds = [];
    } else {
      groupIds = [this.state.group.value];
    }

    SubscriberActions.export(groupIds);
  };

  render() {
    return (
      <div className="PrintSubscribers PrintSettingSection">
        <Fieldset>
          <Legend>
            Participants
            <p>Export PDFs of all the participants in your classes.</p>
          </Legend>

          <SettingsContainer>
            <Columns2 gutter="small">
              <Field>
                <Label>Class</Label>
                <Select
                  ref="select"
                  options={this.state.groupOptions}
                  value={this.state.group.value}
                  onChange={this.setSelectedGroup}
                />
              </Field>
            </Columns2>
          </SettingsContainer>

          <Button size="small" disabled={!this.hasSelectedGroup()} onClick={this.printSubscribers}>
            Export
          </Button>
        </Fieldset>
      </div>
    );
  }
}

export default PrintSubscribers;
